import template from './sw-cms-block-image-bubble-row.html.twig';
import './sw-cms-block-image-bubble-row.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
